import React from "react";
import "../../css/employeemaster.css";

const Step1PersonalDetails = ({ formData, handleChange, nextStep }) => {
  const copyNameToAadhar = (e) => {
    if (e.target.checked) {
      const fullName = `${formData.fName} ${formData.mName} ${formData.lName}`.trim();
      handleChange("nameOnAadharCard")({ target: { value: fullName } });
    }
  };

  // Check if all required fields are filled
  const isNextEnabled =
    formData.birthDate.trim() !== "" &&
    formData.fName.trim() !== "" &&
    formData.lName.trim() !== "";

// style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}
  return (
    <div className="container mt-4" >  
      <div className="card mb-4">
        <div className="card-header bg-primary text-white">Personal Details</div>
        <div className="card-body row g-3">
          
          {/* Employee Code */}
          <div className="col-md-4">
            <label> Employee Code </label>
            <input type="text" className="form-control" placeholder="Auto-generated" value={formData.employeeCode || ""} readOnly/>
          </div>

          {/* Name Row */}
          <div className="row">
            <div className="col-md-4">
              <label> First Name <span className="text-danger">*</span> </label>
              <input type="text" className="form-control" value={formData.fName} onChange={handleChange("fName")} />
            </div>
            <div className="col-md-4">
              <label>Middle Name</label>
              <input type="text" className="form-control" value={formData.mName} onChange={handleChange("mName")} />
            </div>
            <div className="col-md-4">
              <label> Last Name <span className="text-danger">*</span></label>
              <input type="text" className="form-control" value={formData.lName} onChange={handleChange("lName")}/>
            </div>
          </div>

          {/* Aadhar Name */}
          <div className="col-md-8 mt-3">
            <label>Name on Aadhar Card</label>
            <input type="text" className="form-control" placeholder="As per Aadhar Card"
                   value={formData.nameOnAadharCard} onChange={handleChange("nameOnAadharCard")} />
          </div>

          <div className="col-md-4 mt-5 d-flex align-items-end">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="copyNameCheckbox" onChange={copyNameToAadhar} />
              <label className="form-check-label" htmlFor="copyNameCheckbox"> Same as First + Middle + Last Name</label>
            </div>
          </div>

          {/* Gender */}
          <div className="col-md-4">
            <label>Gender</label>
            <select className="form-select" value={formData.gender} onChange={handleChange("gender")}>
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* Birth Date */}
          <div className="col-md-4">
            <label>Birth Date <span className="text-danger">*</span></label>
            <input type="date" className="form-control" name="birthDate" value={formData.birthDate} onKeyDown={(e) => e.preventDefault()}
              onChange={(e) => {
                handleChange("birthDate")({ target: { value: e.target.value } });
              }}
            />
          </div>

          {/* Blood Group */}
          <div className="col-md-4">
            <label>Blood Group</label>
            <select className="form-select" value={formData.bloodGroup} onChange={handleChange("bloodGroup")} >
              <option value="">Select</option>
              <option>A</option>
              <option>A+</option>
              <option>B</option>
              <option>B+</option>
            </select>
          </div>
          

          {/* Family Details Section */}
        <div className="card mb-4 mt-4">
          <div className="card-header bg-secondary text-white">Family Details</div>
          <div className="card-body row g-3">

            {/* Father/Husband */}
            <div className="col-md-4">
              <label>Father/Husband Name</label>
                <input type="text" className="form-control" value={formData.familyDetails.fatherHusbandName}
                        onChange={handleChange("familyDetails", "fatherHusbandName")}/>
            </div>
            <div className="col-md-4">
              <label>DOB</label>
              <input type="date"  className="form-control" value={formData.familyDetails.fatherHusbandDOB || ""} onKeyDown={(e) => e.preventDefault()}
                  onChange={handleChange("familyDetails", "fatherHusbandDOB")}/>
            </div>

            <div className="col-md-4">
              <label>Relation</label>
              <select className="form-select" value={formData.familyDetails.fatherHusbandRelation}
                    onChange={handleChange("familyDetails", "fatherHusbandRelation")}>
                <option value="">Select</option>
                <option value="Father">Father</option>
                <option value="Husband">Husband</option>
              </select>    
            </div>

            {/* Mother/Wife */}
            <div className="col-md-4">
              <label>Mother/Wife Name</label>
              <input type="text" className="form-control" value={formData.familyDetails.motherWifeName}
                      onChange={handleChange("familyDetails", "motherWifeName")}/>
            </div>
            <div className="col-md-4">
              <label>DOB</label>
              <input type="date"  className="form-control" value={formData.familyDetails.motherWifeDOB || ""} onKeyDown={(e) => e.preventDefault()}
                  onChange={handleChange("familyDetails", "motherWifeDOB")}/>
            </div>
            <div className="col-md-4">
              <label>Relation</label>
              <select className="form-select" value={formData.familyDetails.motherWifeRelation}
                      onChange={handleChange("familyDetails", "motherWifeRelation")}>
                <option value="">Select</option>
                <option value="Mother">Mother</option>
                <option value="Wife">Wife</option>
              </select>
            </div>

            {/* Child 1 */}
            <div className="col-md-4">
              <label>Child1 Name</label>
              <input type="text" className="form-control" value={formData.familyDetails.child1Name}
                      onChange={handleChange("familyDetails", "child1Name")} />
            </div>
            <div className="col-md-4">
              <label>Child1 DOB</label>
              <input type="date"  className="form-control" value={formData.familyDetails.child1DOB || ""} onKeyDown={(e) => e.preventDefault()}
                      onChange={handleChange("familyDetails", "child1DOB")}/>
            </div>
            <div className="col-md-4">
              <label>Child1 Gender</label>
              <select className="form-select" value={formData.familyDetails.child1Gender} 
                      onChange={handleChange("familyDetails", "child1Gender")}>
                <option value="">Select</option>
                <option value="Female">Female</option>
                <option value="Male">Male</option>
              </select>
            </div>

            {/* Child 2 */}
            <div className="col-md-4">
              <label>Child2 Name</label>
              <input type="text" className="form-control" value={formData.familyDetails.child2Name}
                        onChange={handleChange("familyDetails", "child2Name")}/>
            </div>
            <div className="col-md-4">
              <label>Child2 DOB</label>
              <input type="date"  className="form-control" value={formData.familyDetails.child2DOB || ""} onKeyDown={(e) => e.preventDefault()}
                  onChange={handleChange("familyDetails", "child2DOB")}/>
            </div>
            <div className="col-md-4">
              <label>Child2 Gender</label>
              <select className="form-select" value={formData.familyDetails.child2Gender}
                      onChange={handleChange("familyDetails", "child2Gender")}>
                <option value="">Select</option>
                <option value="Female">Female</option>
                <option value="Male">Male</option>
              </select>
            </div>
          </div>
        </div>

          {/* Next Button */}
          <div className="col-12 mt-4 text-end">
            <button
              className="btn btn-primary" onClick={nextStep} disabled={!isNextEnabled}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );


};

export default Step1PersonalDetails;







  // style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}
  // return (
  //   <div className="container mt-4" >  
  //     <div className="card mb-4">
  //       <div className="card-header bg-primary text-white">Personal Details</div>
  //       <div className="card-body row g-3">
          
  //         {/* Employee Code */}
  //         <div className="col-md-4">
  //           <label> Employee Code </label>
  //           <input type="text" className="form-control" placeholder="Auto-generated" value={formData.employeeCode || ""} readOnly/>
  //         </div>

  //         {/* Name Row */}
  //         <div className="row">
  //           <div className="col-md-4">
  //             <label> First Name <span className="text-danger">*</span> </label>
  //             <input type="text" className="form-control" value={formData.fName} onChange={handleChange("fName")} />
  //           </div>
  //           <div className="col-md-4">
  //             <label>Middle Name</label>
  //             <input type="text" className="form-control" value={formData.mName} onChange={handleChange("mName")} />
  //           </div>
  //           <div className="col-md-4">
  //             <label> Last Name <span className="text-danger">*</span></label>
  //             <input type="text" className="form-control" value={formData.lName} onChange={handleChange("lName")}/>
  //           </div>
  //         </div>

  //         {/* Aadhar Name */}
  //         <div className="col-md-8 mt-3">
  //           <label>Name on Aadhar Card</label>
  //           <input type="text" className="form-control" placeholder="As per Aadhar Card"
  //                  value={formData.nameOnAadharCard} onChange={handleChange("nameOnAadharCard")} />
  //         </div>

  //         <div className="col-md-4 mt-5 d-flex align-items-end">
  //           <div className="form-check">
  //             <input className="form-check-input" type="checkbox" id="copyNameCheckbox" onChange={copyNameToAadhar} />
  //             <label className="form-check-label" htmlFor="copyNameCheckbox"> Same as First + Middle + Last Name</label>
  //           </div>
  //         </div>

  //         {/* Gender */}
  //         <div className="col-md-4">
  //           <label>Gender</label>
  //           <select className="form-select" value={formData.gender} onChange={handleChange("gender")}>
  //             <option value="">Select</option>
  //             <option value="Male">Male</option>
  //             <option value="Female">Female</option>
  //             <option value="Other">Other</option>
  //           </select>
  //         </div>

  //         {/* Birth Date */}
  //         <div className="col-md-4">
  //           <label>Birth Date <span className="text-danger">*</span></label>
  //           <input type="date" className="form-control" name="birthDate" value={formData.birthDate} onKeyDown={(e) => e.preventDefault()}
  //             onChange={(e) => {
  //               handleChange("birthDate")({ target: { value: e.target.value } });
  //             }}
  //           />
  //         </div>

  //         {/* Blood Group */}
  //         <div className="col-md-4">
  //           <label>Blood Group</label>
  //           <select className="form-select" value={formData.bloodGroup} onChange={handleChange("bloodGroup")} >
  //             <option value="">Select</option>
  //             <option>A</option>
  //             <option>A+</option>
  //             <option>B</option>
  //             <option>B+</option>
  //           </select>
  //         </div>
          

  //         {/* Family Details Section */}
  //       <div className="card mb-4 mt-4">
  //         <div className="card-header bg-secondary text-white">Family Details</div>
  //         <div className="card-body row g-3">

  //           {/* Father/Husband */}
  //           <div className="col-md-4">
  //             <label>Father/Husband Name</label>
  //               <input type="text" className="form-control" value={formData.familyDetails.fatherHusbandName}
  //                       onChange={handleChange("familyDetails", "fatherHusbandName")}/>
  //           </div>
  //           <div className="col-md-4">
  //             <label>DOB</label>
  //             <input type="date"  className="form-control" value={formData.familyDetails.fatherHusbandDOB || ""} onKeyDown={(e) => e.preventDefault()}
  //                 onChange={handleChange("familyDetails", "fatherHusbandDOB")}/>
  //           </div>

  //           <div className="col-md-4">
  //             <label>Relation</label>
  //             <select className="form-select" value={formData.familyDetails.fatherHusbandRelation}
  //                   onChange={handleChange("familyDetails", "fatherHusbandRelation")}>
  //               <option value="">Select</option>
  //               <option value="Father">Father</option>
  //               <option value="Husband">Husband</option>
  //             </select>    
  //           </div>

  //           {/* Mother/Wife */}
  //           <div className="col-md-4">
  //             <label>Mother/Wife Name</label>
  //             <input type="text" className="form-control" value={formData.familyDetails.motherWifeName}
  //                     onChange={handleChange("familyDetails", "motherWifeName")}/>
  //           </div>
  //           <div className="col-md-4">
  //             <label>DOB</label>
  //             <input type="date"  className="form-control" value={formData.familyDetails.motherWifeDOB || ""} onKeyDown={(e) => e.preventDefault()}
  //                 onChange={handleChange("familyDetails", "motherWifeDOB")}/>
  //           </div>
  //           <div className="col-md-4">
  //             <label>Relation</label>
  //             <select className="form-select" value={formData.familyDetails.motherWifeRelation}
  //                     onChange={handleChange("familyDetails", "motherWifeRelation")}>
  //               <option value="">Select</option>
  //               <option value="Mother">Mother</option>
  //               <option value="Wife">Wife</option>
  //             </select>
  //           </div>

  //           {/* Child 1 */}
  //           <div className="col-md-4">
  //             <label>Child1 Name</label>
  //             <input type="text" className="form-control" value={formData.familyDetails.child1Name}
  //                     onChange={handleChange("familyDetails", "child1Name")} />
  //           </div>
  //           <div className="col-md-4">
  //             <label>Child1 DOB</label>
  //             <input type="date"  className="form-control" value={formData.familyDetails.child1DOB || ""} onKeyDown={(e) => e.preventDefault()}
  //                     onChange={handleChange("familyDetails", "child1DOB")}/>
  //           </div>
  //           <div className="col-md-4">
  //             <label>Child1 Gender</label>
  //             <select className="form-select" value={formData.familyDetails.child1Gender} 
  //                     onChange={handleChange("familyDetails", "child1Gender")}>
  //               <option value="">Select</option>
  //               <option value="Female">Female</option>
  //               <option value="Male">Male</option>
  //             </select>
  //           </div>

  //           {/* Child 2 */}
  //           <div className="col-md-4">
  //             <label>Child2 Name</label>
  //             <input type="text" className="form-control" value={formData.familyDetails.child2Name}
  //                       onChange={handleChange("familyDetails", "child2Name")}/>
  //           </div>
  //           <div className="col-md-4">
  //             <label>Child2 DOB</label>
  //             <input type="date"  className="form-control" value={formData.familyDetails.child2DOB || ""} onKeyDown={(e) => e.preventDefault()}
  //                 onChange={handleChange("familyDetails", "child2DOB")}/>
  //           </div>
  //           <div className="col-md-4">
  //             <label>Child2 Gender</label>
  //             <select className="form-select" value={formData.familyDetails.child2Gender}
  //                     onChange={handleChange("familyDetails", "child2Gender")}>
  //               <option value="">Select</option>
  //               <option value="Female">Female</option>
  //               <option value="Male">Male</option>
  //             </select>
  //           </div>
  //         </div>
  //       </div>

  //         {/* Next Button */}
  //         <div className="col-12 mt-4 text-end">
  //           <button
  //             className="btn btn-primary" onClick={nextStep} disabled={!isNextEnabled}>
  //             Next
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );


